import { createFileRoute } from "@tanstack/react-router";
import { KontaktPage, kontaktHead } from "@/pages/KontaktPage";

export const Route = createFileRoute("/kontakt-mi-support")({
  head: () => kontaktHead("da"),
  component: () => <KontaktPage locale="da" />,
});
